export default __webpack_public_path__ + "static/media/main-category-fitness.5f420656.jpg";